import { ERibbonColors } from "src/types/enum/ribbon-colors-enum";

const styles: Record<string, React.CSSProperties> = {
    closeButton: {
        position: "absolute",
        top: 0,
        right: 0,
        padding: 10,
        background: "none",
        border: "none",
        color: "white",
        cursor: "pointer",
        fontSize: 16,
    },
    topRibbon: {
        position: "relative",
        height: 40,
        color: "white",
        fontSize: 16,
        padding: 10,
        textAlign: "center",
        marginBottom: 8,
    },
};

interface TopRibbonProps {
    color: ERibbonColors;
    closable: boolean;
    message: string;
    onClose: () => void;
    shown: boolean;
}

const TopRibbon = ({closable, color, message, onClose, shown}: TopRibbonProps) => {
    const bgColor = color === "danger" ? "#ff0000" : color === "warning" ? "#f28f8a" : "transparent";

    if (shown) {
        return (
            <div style={{...styles.topRibbon, backgroundColor: bgColor}}>
                <p style={{margin: 0}}>{message}</p>
                {closable && (
                    <button style={styles.closeButton} onClick={onClose}>
                        X
                    </button>
                )}
            </div>
        );
    } else {
        return null;
    }
};

export default TopRibbon;
